import { Outlet } from 'react-router-dom';
import { I18nProvider } from './contexts/i18n';
import { InitProvider } from './contexts/init';
import { SessionProvider } from './contexts/session';
import { ThemeProvider } from './contexts/theme';

function App() {
  return (
    <InitProvider>
      {(placeholder) => (
        <I18nProvider>
          <ThemeProvider>
            <SessionProvider>{placeholder || <Outlet></Outlet>}</SessionProvider>
          </ThemeProvider>
        </I18nProvider>
      )}
    </InitProvider>
  );
}

export default App;
